// extracted by mini-css-extract-plugin
export default {"component":"pUe0A"};